import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from 'sinoui-components/Form/FormControl/FormLabel';
import { connect } from 'formik';
var PureFormLabel = React.memo(FormLabel);
/**
 * 表单项标签组件。
 *
 * @private
 */
var FormItemLabel = function (_a, _b) {
    var sinouiForm = _b.sinouiForm;
    var formik = _a.formik, props = tslib_1.__rest(_a, ["formik"]);
    // tslint:disable-next-line:no-any
    var otherProps = {};
    if (sinouiForm) {
        otherProps = tslib_1.__assign({ colon: sinouiForm.colon }, sinouiForm.labelProps);
    }
    if (formik && props.name) {
        otherProps.error =
            formik.touched[props.name] && !!formik.errors[props.name];
    }
    var labelProps = tslib_1.__assign({}, otherProps, props);
    labelProps.htmlFor = labelProps.htmlFor || labelProps.name;
    labelProps.align = labelProps.vertical ? 'left' : labelProps.align;
    labelProps.width = labelProps.inline ? 'auto' : labelProps.width;
    return React.createElement(PureFormLabel, tslib_1.__assign({}, labelProps));
};
FormItemLabel.contextTypes = {
    sinouiForm: PropTypes.object,
};
export default connect(FormItemLabel);
//# sourceMappingURL=FormItemLabel.js.map